import type React from "react";
import type { FormHandles } from "@unform/core";

type CepEventLike =
    | React.FocusEvent<HTMLInputElement>
    | React.ChangeEvent<HTMLInputElement>
    | { target: { value: string } };

export const globalCheckCEP = async (formRef: React.RefObject<FormHandles>, event: CepEventLike) => {
    const cep = String(event?.target?.value ?? "").replace(/\D/g, "");

    if (cep.length !== 8) return;

    const response = await fetch(`https://viacep.com.br/ws/${cep}/json/`);
    const data = await response.json();
    if (data?.erro) return;

    formRef.current?.setFieldValue("addressZipcode", data.cep ?? "");
    formRef.current?.setFieldValue("addressStreet", data.logradouro ?? "");
    formRef.current?.setFieldValue("residenceTypeo", "");
    formRef.current?.setFieldValue("addressDistrict", data.bairro ?? "");
    formRef.current?.setFieldValue("addressCity", data.localidade ?? "");
    formRef.current?.setFieldValue("addressState", data.uf ?? "");
    formRef.current?.setFieldValue("addressIBGE", data.ibge ?? "");
};